/* eslint-disable */
export default {
  participants: '参与者',
  host: '（主持人）',
  removeParticipant: '移除参与者',
  removeTitle: '移除参与者',
  removeDescription: '是否将 {name} 从此会议中移除？',
  confirmButtonText: '移除',
  cancelButtonText: '取消',
} as const;

// @key: @#@"participants"@#@ @source: @#@"Participants"@#@
// @key: @#@"host"@#@ @source: @#@"(Host)"@#@
// @key: @#@"removeParticipant"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeTitle"@#@ @source: @#@"Remove participant"@#@
// @key: @#@"removeDescription"@#@ @source: @#@"Remove {name} from this conference?"@#@
// @key: @#@"confirmButtonText"@#@ @source: @#@"Remove"@#@
// @key: @#@"cancelButtonText"@#@ @source: @#@"Cancel"@#@
